import { css, Interpolation, Theme } from '@emotion/react'
import { typographyClasses, switchClasses } from '@mui/material'

export const switchElement: Interpolation<Theme> = (theme) => css`
  margin-left: 0;

  .${typographyClasses.root} {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.colors.gray};

    user-select: none;
  }

  .${switchClasses.disabled} {
    color: ${theme.colors.typographyFour};
  }
`
